import ProductsAPI from '../../api/products';

const state = {
  records: [],
  uiFlags: { isFetching: false, isCreating: false, isUpdating: false, isDeleting: false },
};

const getters = {
  getProducts: $state => $state.records,
  getActiveProducts: $state => $state.records.filter(p => p.active),
  getUIFlags: $state => $state.uiFlags,
  getProductById: $state => id => $state.records.find(p => p.id === Number(id)),
};

const mutations = {
  SET_PRODUCTS($state, records) { $state.records = records; },
  ADD_PRODUCT($state, record) { $state.records.push(record); },
  UPDATE_PRODUCT($state, record) {
    const i = $state.records.findIndex(r => r.id === record.id);
    if (i !== -1) $state.records.splice(i, 1, record);
  },
  DELETE_PRODUCT($state, id) {
    $state.records = $state.records.filter(r => r.id !== id);
  },
  SET_UI_FLAG($state, flag) { $state.uiFlags = { ...$state.uiFlags, ...flag }; },
};

const actions = {
  async fetch({ commit }) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await ProductsAPI.get();
      commit('SET_PRODUCTS', data.payload);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },
  async create({ commit }, payload) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const { data } = await ProductsAPI.create({ product: payload });
      commit('ADD_PRODUCT', data);
      return data;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },
  async update({ commit }, { id, ...payload }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await ProductsAPI.update(id, { product: payload });
      commit('UPDATE_PRODUCT', data);
      return data;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },
  async delete({ commit }, id) {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await ProductsAPI.delete(id);
      commit('DELETE_PRODUCT', id);
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },
};

export default { namespaced: true, state, getters, mutations, actions };
